module.exports = __webpack_public_path__ + "img/90d18b9.png";